// Query-key factory. Every key is parameterised by organisation scope
// (null → personal, "all" → mixed, else <uuid>) so cache entries from one
// scope can't leak into another when the user switches context. The scope
// key is the org id string or "personal" / "all" — never null — because
// React Query serialises keys and a literal null would match too eagerly.

type Scope = string | "personal" | "all";

function scopeKey(organisationId?: string | null): Scope {
  if (organisationId === "personal") return "personal";
  if (organisationId) return organisationId;
  return "all";
}

export const projectKeys = {
  all: ["projects"] as const,
  lists: (organisationId?: string | null) =>
    [...projectKeys.all, "list", scopeKey(organisationId)] as const,
  stats: (
    id: string,
    versionId?: string | null,
    organisationId?: string | null,
  ) =>
    [
      ...projectKeys.all,
      "stats",
      scopeKey(organisationId),
      id,
      versionId ?? "current",
    ] as const,
  extractionStatus: (
    id: string,
    versionId?: string | null,
    organisationId?: string | null,
  ) =>
    [
      ...projectKeys.all,
      "extractionStatus",
      scopeKey(organisationId),
      id,
      versionId ?? "current",
    ] as const,
  graph: (
    id: string,
    versionId?: string | null,
    organisationId?: string | null,
  ) =>
    [
      ...projectKeys.all,
      "graph",
      scopeKey(organisationId),
      id,
      versionId ?? "current",
    ] as const,
  componentDatasheet: (
    id: string,
    ref: string,
    versionId?: string | null,
    organisationId?: string | null,
  ) =>
    [
      ...projectKeys.all,
      "componentDatasheet",
      scopeKey(organisationId),
      id,
      ref,
      versionId ?? "current",
    ] as const,
};
